import React, { useCallback } from 'react';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { PrimaryNavigationMenuItem } from 'components/ui';
import { Tooltip } from 'components/ui/Tooltip';
import { VALUATION_APPROACHES_TEST_IDS } from 'pages/ValuationsAllocation/ValuationApproaches.testIds';
import { TabActionOptionProps } from './types';

const getActionIcon = (actionText?: string) => {
  const normalizedActionText = actionText?.toLowerCase() ?? '';

  if (normalizedActionText.includes('delete')) {
    return <DeleteOutlineOutlinedIcon />;
  }

  if (normalizedActionText.includes('edit')) {
    return <EditOutlinedIcon />;
  }

  if (normalizedActionText.includes('financial statement')) {
    return <DescriptionOutlinedIcon />;
  }

  return undefined;
};

const TabActionOption = <T, R>(props: TabActionOptionProps<T, R>) => {
  const {
    actionText,
    argumentsList,
    children,
    disabled = false,
    onClick,
    closeApproachMenu,
    tooltipMessage,
    shouldDisplayTooltip = false,
  } = props;

  const onClickHandler = useCallback(() => {
    closeApproachMenu?.();

    if (argumentsList) {
      onClick?.(...argumentsList);
    }
  }, [closeApproachMenu, onClick, argumentsList]);
  const itemTone = actionText?.toLowerCase().includes('delete') ? 'danger' : 'default';
  const actionIcon = getActionIcon(actionText);

  return (
    <Tooltip
      disableInteractive
      placement="right"
      title={shouldDisplayTooltip && tooltipMessage ? tooltipMessage : ''}>
      <span>
        <PrimaryNavigationMenuItem
          data-testid={
            actionText ? VALUATION_APPROACHES_TEST_IDS.approachMenuAction(actionText) : undefined
          }
          disabled={disabled}
          endIcon={children}
          icon={actionIcon}
          onClick={onClickHandler}
          tone={itemTone}>
          {actionText}
        </PrimaryNavigationMenuItem>
      </span>
    </Tooltip>
  );
};

export default TabActionOption;
